import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let OneSectorPageThunk = createAsyncThunk(
	"SectorSolution/OneSectorPageThunk",
	async (arg, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.get(`/api/admin/sector_solutions/${arg?.id}`);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data.data);
		}
	}
);
